import { color as designColor, query } from '@design/templateFns';
import { StyledSvg } from 'icons';
import Link from 'next/link';
import styled from 'styled-components';

interface LogoProps {
  fillColor?: string; // svg is set to change color based on 'color' attribute of svg or parent.  fillColor may not be needed in most cases
  size?: string;
  dataTestId?: string;
}

export const Logo = ({
  fillColor = designColor('fg')(), // whatever fillColor is passed in will be the 'Engels' and 'Volkers' color
  size = '200px',
  dataTestId = 'logo',
}: LogoProps) => {
  const evRed = designColor('cta')(); // red is the same color on light or dark backgrounds

  return (
    <Link href="/" data-testid={dataTestId}>
      <LogoWrapper $size={size}>
        <StyledSvg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 400 45"
          x="0"
          y="0"
          width="400"
          height="45"
          scale={1}
          color={fillColor}
        >
          <path
            fill={evRed}
            d="M172.594,27.539c0.636-1.55,0.954-3.425,0.954-5.611h3.737c0,3.313-0.687,6.101-2.045,8.347
              c0.61,0.576,1.202,0.972,1.778,1.187c0.575,0.215,1.262,0.319,2.053,0.319h0.911v3.467h-0.73c-0.757,0-1.427-0.025-2.002-0.094
              c-0.546-0.053-1.082-0.174-1.598-0.361c-0.488-0.178-0.948-0.424-1.366-0.731c-0.481-0.35-0.937-0.733-1.366-1.145
              c-2.123,1.764-4.872,2.651-8.248,2.651c-2.972,0-5.284-0.68-6.925-2.032c-1.641-1.351-2.457-3.26-2.457-5.721
              c0-1.731,0.447-3.227,1.341-4.475c0.893-1.248,2.363-2.402,4.398-3.468c-0.911-1.067-1.572-2.065-1.984-3.012
              c-0.401-0.905-0.609-1.884-0.611-2.874c0-1.824,0.619-3.295,1.864-4.422c1.247-1.128,2.888-1.688,4.923-1.688
              c2.037,0,3.678,0.551,4.923,1.643c1.245,1.094,1.864,2.556,1.864,4.38c0.014,1.32-0.419,2.606-1.229,3.649
              c-0.825,1.067-2.174,2.125-4.055,3.192l5.877,6.798h-0.008L172.594,27.539z M163.212,22.383c-1.306,0.672-2.251,1.403-2.843,2.194
              c-0.593,0.792-0.886,1.721-0.886,2.78c0,1.523,0.55,2.711,1.641,3.58c1.091,0.869,2.552,1.299,4.373,1.299
              c1.942,0,3.565-0.533,4.872-1.6l-7.148-8.26l-0.008,0.008V22.383z M164.621,18.322c1.306-0.697,2.217-1.368,2.732-2.005
              c0.515-0.636,0.773-1.402,0.773-2.28c0-0.972-0.25-1.711-0.757-2.211c-0.498-0.5-1.202-0.748-2.121-0.748s-1.633,0.232-2.166,0.705
              c-0.532,0.473-0.798,1.135-0.798,1.988c0,0.637,0.172,1.309,0.523,2.005c0.353,0.697,0.945,1.549,1.796,2.555L164.621,18.322
              L164.621,18.322z"
          />
          <path
            fill={fillColor}
            d="M1,8.787h23.686v4.656H6.146v9.577h15.807v4.655H6.146v10.68h18.952v4.655H1V8.787z
              M30.932,8.787h6.469l16.401,27.426V8.787h5.008v34.215h-6.468L35.941,15.576v27.426h-5.008V8.787H30.932z M81.949,25.12h14.897
              v17.891h-3.737l-0.412-5.568c-0.492,1.01-1.155,1.927-1.959,2.711c-0.825,0.809-1.769,1.489-2.844,2.057
              c-1.082,0.559-2.259,1.008-3.556,1.325c-1.333,0.325-2.7,0.487-4.072,0.482c-2.338,0-4.468-0.422-6.375-1.256
              c-1.886-0.814-3.567-2.037-4.923-3.58c-1.366-1.549-2.431-3.417-3.188-5.593c-0.757-2.178-1.134-4.604-1.134-7.28
              c0-2.677,0.404-5.284,1.212-7.556c0.807-2.264,1.951-4.207,3.436-5.817c1.487-1.61,3.274-2.856,5.352-3.743
              c2.08-0.878,4.398-1.325,6.951-1.325c1.976,0,3.797,0.267,5.464,0.801c1.666,0.533,3.143,1.299,4.415,2.307
              c1.272,1.006,2.32,2.211,3.144,3.631c0.825,1.41,1.384,3.002,1.685,4.766h-5.242c-0.575-2.065-1.727-3.691-3.436-4.862
              c-1.719-1.17-3.789-1.755-6.22-1.755c-1.702,0-3.248,0.292-4.649,0.886c-1.368,0.574-2.596,1.437-3.599,2.53
              c-1.005,1.092-1.778,2.401-2.32,3.924c-0.55,1.524-0.816,3.227-0.816,5.112v1.463c0,1.945,0.258,3.692,0.773,5.223
              c0.515,1.542,1.263,2.84,2.235,3.899c0.979,1.072,2.185,1.913,3.529,2.462c1.384,0.576,2.939,0.868,4.666,0.868
              c1.606,0,3.101-0.24,4.484-0.731c1.383-0.482,2.578-1.152,3.574-2.004c0.988-0.831,1.795-1.856,2.371-3.012
              c0.582-1.177,0.879-2.474,0.868-3.786H81.957v-4.475C81.957,25.112,81.949,25.12,81.949,25.12z M103.45,8.787h23.686v4.656h-18.538
              v9.577h15.807v4.655h-15.807v10.68h18.952v4.655h-24.098V8.787H103.45z M133.382,8.787h5.146v29.559h16.349v4.656h-21.504V8.787
              C133.373,8.787,133.382,8.787,133.382,8.787z M180.806,8.787h5.559l9.613,28.518l9.614-28.517h5.241l-11.891,34.222h-6.193
              L180.816,8.787h-0.008H180.806z M228.909,44.009c-2.456,0-4.708-0.439-6.743-1.325c-1.996-0.853-3.788-2.12-5.259-3.717
              c-1.477-1.602-2.611-3.493-3.419-5.706c-0.807-2.203-1.211-4.647-1.211-7.323c0-2.677,0.412-5.12,1.229-7.323
              c0.825-2.203,1.959-4.105,3.419-5.706c1.46-1.601,3.247-2.869,5.241-3.717c2.035-0.878,4.287-1.325,6.743-1.325
              c2.457,0,4.709,0.439,6.744,1.325c1.99,0.854,3.776,2.121,5.241,3.717c1.46,1.602,2.595,3.502,3.419,5.706
              c0.825,2.203,1.229,4.647,1.229,7.323c0,2.677-0.404,5.12-1.212,7.323c-0.807,2.203-1.941,4.105-3.419,5.706
              c-1.469,1.598-3.261,2.865-5.258,3.717C233.618,43.562,231.375,44.009,228.909,44.009L228.909,44.009z M228.909,39.13
              c1.702,0,3.239-0.293,4.623-0.887c1.35-0.57,2.556-1.435,3.531-2.53c0.97-1.092,1.735-2.401,2.277-3.924
              c0.55-1.523,0.825-3.21,0.825-5.068v-1.55c0-1.858-0.275-3.545-0.825-5.068c-0.55-1.524-1.315-2.833-2.302-3.925
              c-0.987-1.092-2.201-1.956-3.557-2.53c-1.384-0.593-2.904-0.886-4.58-0.886c-1.676,0-3.196,0.293-4.579,0.886
              c-1.356,0.574-2.57,1.437-3.557,2.53c-0.988,1.094-1.753,2.401-2.303,3.924c-0.55,1.524-0.816,3.21-0.816,5.069v1.549
              c0,1.858,0.275,3.546,0.816,5.069c0.55,1.523,1.306,2.831,2.277,3.924c0.981,1.099,2.196,1.964,3.557,2.53
              c1.401,0.594,2.929,0.887,4.597,0.887H228.909z M221.383,0.983h5.009v4.879h-5.009V0.983z M231.401,0.983h5.009v4.879h-5.009V0.983z
              M251.35,8.787h5.146v29.559h16.35v4.656h-21.505V8.787H251.35L251.35,8.787z M277.958,8.787h5.145V25.62l16.539-16.833h6.469
              l-13.807,13.872l14.348,20.351h-6.238l-11.659-16.789l-5.653,5.705v11.084h-5.145V8.787z M310.94,8.787h23.686v4.656h-18.541v9.577
              h15.809v4.655h-15.809v10.68h18.953v4.655H310.94V8.787z M340.872,8.787h15.807c1.608,0,3.058,0.225,4.348,0.663
              c1.288,0.439,2.388,1.067,3.299,1.867c0.906,0.804,1.63,1.793,2.123,2.901c0.497,1.127,0.747,2.392,0.747,3.786
              c0,2.004-0.507,3.734-1.53,5.18c-1.013,1.446-2.466,2.522-4.347,3.219c1.186,0.335,2.088,0.904,2.706,1.713
              c0.619,0.808,1.101,1.996,1.435,3.58l2.277,11.316h-5.284L360.4,32.426c-0.121-0.697-0.301-1.274-0.525-1.713
              c-0.212-0.419-0.525-0.78-0.91-1.049c-0.379-0.258-0.859-0.44-1.435-0.551c-0.576-0.112-1.306-0.164-2.182-0.164h-9.339v14.053
              h-5.145V8.787H340.872L340.872,8.787z M355.589,24.621c1.941,0,3.504-0.507,4.69-1.531c1.186-1.016,1.778-2.393,1.778-4.131
              c0-1.739-0.583-3.107-1.752-4.131c-1.169-1.016-2.741-1.532-4.716-1.532h-9.563v11.316h9.563V24.621z M376.405,32.375
              c0.455,4.715,3.6,7.073,9.433,7.073c5.249,0,7.877-1.885,7.877-5.653c0-1.343-0.361-2.384-1.091-3.15
              c-0.73-0.757-1.992-1.385-3.779-1.867l-8.523-2.418c-2.672-0.758-4.64-1.842-5.903-3.235c-1.262-1.403-1.89-3.227-1.89-5.474
              c0-3.106,1.091-5.507,3.282-7.21c2.182-1.704,5.266-2.556,9.245-2.556c4.218,0,7.44,0.973,9.656,2.917
              c2.217,1.945,3.385,4.811,3.505,8.58h-5.06c-0.215-2.462-0.954-4.234-2.207-5.319c-1.263-1.076-3.257-1.618-5.989-1.618
              c-4.768,0-7.147,1.602-7.147,4.793c0,1.155,0.335,2.083,1.005,2.78c0.669,0.698,1.804,1.274,3.419,1.739l8.513,2.418
              c2.947,0.852,5.06,1.979,6.332,3.373c1.272,1.403,1.916,3.305,1.916,5.706c0,3.434-1.159,6.093-3.488,7.96
              c-2.32,1.867-5.628,2.805-9.906,2.805c-4.279,0-7.827-0.998-10.276-2.986c-2.448-1.988-3.771-4.87-3.986-8.648h5.06L376.405,32.375
              L376.405,32.375z"
          />
        </StyledSvg>
      </LogoWrapper>
    </Link>
  );
};

export const LogoWrapper = styled.div<{ $size: string }>`
  display: inline-block;
  //check if size is passed, if not, use 100%
  width: ${({ $size }) => ($size ? $size : '100%')};

  @media screen and (${query.below('tablet')}) {
    width: 160px;
  }

  svg {
    display: inline-block;
    width: 100%;
    height: auto;
  }
`;
